<nz-form-item>
  <div style="padding: 6px">
    <label [attr.for]="inputId" [ngClass]="labelClass" [class.required-label]="required">{{ label }}</label>
    @if (secondLabel) {
    <span [ngClass]="secondLabelClass" style="margin-left: 4px">{{ secondLabel }}</span>
    }
  </div>
  <nz-form-control [nzValidateStatus]="convertErrorsNz[inputFormControl.status]">
    <nz-input-number [id]="inputId" [ngClass]="inputClass" [formControl]="asFormControl(inputFormControl)" [ngStyle]="{ width: fullWidth ? '100%' : '' }"> </nz-input-number>
    <app-form-item-error [touched]="inputFormControl.touched" [errors]="inputFormControl.errors"></app-form-item-error>
  </nz-form-control>
</nz-form-item>
